module.exports = __webpack_public_path__ + "img/cooperation25.b452a83f.png";